import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Refund Policy</h1>
      <p><strong>Effective Date:</strong> 27/05/2025</p>

      <p>
        At <strong>IMPACT</strong>, we value transparency and professionalism in our operations. Before proceeding with any payments on our website (<a href="https://impactjournal.co.in">https://impactjournal.co.in</a>), we strongly encourage all users to read and understand our refund policy.
      </p>

      <h2>1. No Refund Policy</h2>
      <p>
        All payments made towards manuscript submission, publication fees, processing charges, or any related services are <strong>non-refundable</strong>. Once a transaction is completed, it is considered final.
      </p>

      <h2>2. Reason for No Refund</h2>
      <ul>
        <li>Editorial and processing work begins immediately after submission.</li>
        <li>Peer review and administrative tasks consume time and resources.</li>
        <li>Certificates and publication workflows are generated based on submission.</li>
      </ul>

      <h2>3. Exceptions</h2>
      <p>
        Refunds will <strong>only</strong> be considered in the case of duplicate payments made in error. A formal refund request must be submitted to <strong>support@impactjournal.co.in</strong> within 3 days of the transaction, including valid payment proof.
      </p>

      <h2>4. Contact Us</h2>
      <p>
        For any questions or clarification regarding this policy, please contact us at:
        <br />
        <strong>support@impactjournal.co.in</strong>
      </p>
    </div>
  );
};

export default RefundPolicy;
